import * as gzColumns from './columns.service';
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';

export default angular.module('gazelle.extensions.grid.columns', [
  gazelleAnalytics
])
  .service(gzColumns.name, gzColumns.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/extensions/grid/columns/columns.module.js